module.exports = "/fonts/nucleo-icons.woff2?ec16bc4cc4526801004db5bbe3b8e2c6";